import { GaTrackingEventCategory } from '~shared/modules/ga-tracking/constants';
import { ApplicationEventType } from '../constants';
import { ApplicationEvent } from './application-event.model';

export class InvalidOfferForRegionApplicationEvent implements ApplicationEvent {
  type = ApplicationEventType.InvalidOfferForRegion;

  getPayload(): any {
    return {
      label: 'Invalid offer for region on cart',
      gtmCustom: {
        category: GaTrackingEventCategory.Notifications,
      }
    };
  }
}
